import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import BeachAccessOutlinedIcon from '@mui/icons-material/BeachAccessOutlined';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import Groups2OutlinedIcon from '@mui/icons-material/Groups2Outlined';
import PendingActionsOutlinedIcon from '@mui/icons-material/PendingActionsOutlined';
import SettingsSuggestOutlinedIcon from '@mui/icons-material/SettingsSuggestOutlined';
import React from 'react';
import { Navigate } from 'react-router-dom';
import AdminHolidays from '../../../app/admin/calendar';
import AdminDashboard from '../../../app/admin/dashboard';
import AdminDepartments from '../../../app/admin/departments';
import DepartmentUpdate from '../../../app/admin/departments/components/DepartmentUpdate';
import AdminEmployees from '../../../app/admin/employees';
import EmployeePreview from '../../../app/admin/employees/preview/EmployeePreview';
import AdminLeaveDays from '../../../app/admin/leave-days';
import AdminNotifications from '../../../app/admin/notifications';
import AdminOfficeOrderly from '../../../app/admin/office-orderly';
import AdminProjects from '../../../app/admin/projects';
import AdminRefund from '../../../app/admin/refund';
import RefundCreate from '../../../app/admin/refund/components/RefundCreate';
import RefundUpdate from '../../../app/admin/refund/components/RefundUpdate';
import AdminSettings from '../../../app/admin/settings';
import UserEmployeesUpdate from '../../../app/user/employees';
import ProjectUpdate from '../../../app/user/projects';
import { EModules } from '../../../shared/enums/modules/EModules';

export const userRoutes = [
  {
    path: '/user/dashboard',
    module: EModules.DASHBOARD,
    showInSidebar: true,
    title: 'header.dashboard',
    component: <AdminDashboard />,
    icon: <DashboardOutlinedIcon />,
  },
  {
    path: '/user/employees',
    module: EModules.USERS,
    showInSidebar: true,
    title: 'header.employees',
    component: <AdminEmployees />,
    icon: <Groups2OutlinedIcon />,
  },

  {
    module: EModules.USERS,
    path: '/user/employee/:id/:tab',
    component: <UserEmployeesUpdate />,
  },
  {
    module: EModules.USERS,
    path: '/user/employee/preview/:id/',
    showInSidebar: false,
    title: 'header.employee',
    component: <EmployeePreview />,
  },
  {
    module: EModules.DEPARTMENTS,
    path: '/user/departments',
    showInSidebar: true,
    title: 'header.departments',
    component: <AdminDepartments />,
    icon: <BadgeOutlinedIcon />,
  },
  {
    module: EModules.DEPARTMENTS,
    path: '/user/departments/:id',
    component: <DepartmentUpdate />,
  },
  {
    module: EModules.PROJECTS,
    path: '/user/projects',
    showInSidebar: true,
    title: 'header.projects',
    component: <AdminProjects />,
    icon: <AccountTreeOutlinedIcon />,
  },
  {
    module: EModules.PROJECTS,
    path: '/user/projects/:id',
    component: <ProjectUpdate />,
  },
  {
    module: EModules.LEAVE_DAYS,
    path: '/user/leave-days',
    showInSidebar: true,
    title: 'header.leaveDays',
    component: <AdminLeaveDays />,
    icon: <BeachAccessOutlinedIcon />,
  },
  {
    module: EModules.CALENDAR,
    path: '/user/calendar',
    showInSidebar: true,
    title: 'header.calendar',
    component: <AdminHolidays />,
    icon: <CalendarMonthIcon />,
  },
  {
    module: EModules.OFFICE_ORDERLY,
    path: '/user/office-orderly',
    showInSidebar: true,
    title: 'header.officeOrderly',
    component: <AdminOfficeOrderly />,
    icon: <PendingActionsOutlinedIcon />,
  },
  {
    module: EModules.REFUND,
    path: '/user/refund',
    showInSidebar: true,
    title: 'header.refund',
    component: <AdminRefund />,
    icon: <CurrencyExchangeIcon />,
  },
  {
    module: EModules.REFUND,
    path: '/user/refund/create',
    component: <RefundCreate />,
  },
  {
    module: EModules.REFUND,
    path: '/user/refund/:id',
    component: <RefundUpdate />,
  },
  {
    module: EModules.NOTIFICATION,
    path: '/user/notifications',
    showInSidebar: false,
    title: 'header.notifications',
    component: <AdminNotifications />,
  },
  {
    path: '/user/settings',
    showInSidebar: true,
    title: 'header.settings',
    component: <AdminSettings />,
    icon: <SettingsSuggestOutlinedIcon />,
  },
  {
    path: '*',
    component: <Navigate to="/user/dashboard" />,
  },
];
